import React from 'react'
import BaseComponent from "../pages/base/BaseComponent";
import {Button, Card, Col, Form, Modal, Row} from "@themesberg/react-bootstrap";
import label from "enqc-utilities/src/label/Label"
import PropTypes from 'prop-types';
import ApplicationIcons from "enqc-utilities/src/misc/ApplicationIcons";
import {cleanNonNumeric, isEmpty} from "enqc-utilities/src/utils/Utilities";
import Endpoint from "enqc-utilities/src/api/Endpoint";

export default class AssemblyFromFindInspectionModal extends BaseComponent{

    constructor(props) {
        super(props);
        let state = this.state
        state.search = ''
        state.serverMessage = ''
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if(nextProps!=this.props){
            let {show} = nextProps
            if(show){
                this.setState({search:''}, () => {
                    if(show){
                        // window.history.pushState({ show: true }, '');
                        this.handlePopState = (event) =>{
                            if (show) {
                                this.props.onClose()
                                // window.history.pushState(null, ''); // re-push state to prevent deep back
                                window.history.pushState({ show: true }, '');
                            }
                        }
                        window.addEventListener('popstate', this.handlePopState);
                    }else{
                        window.removeEventListener('popstate', this.handlePopState);
                    }
                })
            }
        }
    }

    findInspection=(keyword)=>{
        if(isEmpty(keyword)){
            return;
        }
        let {onSearchResult} = this.props
        if(!onSearchResult){
            onSearchResult = () => {}
        }
        this.showPostProgress()
        this.get(Endpoint.API.INSPECTION_FIND_WITH_NO_ASSEMBLY_EXISTS, {
            params:{keyword:keyword}
        }, null, response=>{
            this.closePostProgress()
            if(response.code===200){
                let inspection = response.data
                onSearchResult(inspection)
            }else{
                this.setState({
                    serverMessage:response.messageError??response.message,
                })
            }
        }, false, false)
    }



    render() {
        let {search, serverMessage} = this.state
        let {show} = this.props

        return (
            <>
                {super.render()}
                <Modal
                    as={Modal.Dialog}
                    size="md"
                    centered
                    show={show} onHide={()=>{}}>
                    <Modal.Header className="text-center d-block">
                        <Modal.Title className="h3">{label.SearchInspection}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="text-center">
                        <Row>
                            <Col className="p-0 mb-1">
                                <Card.Img style={{width:'35%'}} size="sm" src={ApplicationIcons.Icons.inspection}/>
                            </Col>
                        </Row>
                        <Row>
                            <Col className="mb-3">
                                <span className="fs-6 text-dark" dangerouslySetInnerHTML={{__html: label.AssemblyGenerationFromInspectionWarningMessage}}/>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <span className="text-italic">{label.FindReferenceOrSerialFromExistingInspection}</span>
                                <Form.Control
                                    className="text-center h1"
                                    style={{ fontSize: '1.5rem' }}
                                    value={search}
                                    type="text"
                                    placeholder={"00000000000"}
                                    onChange={event=>{
                                        let value = event.target.value
                                        value = cleanNonNumeric(value)
                                        this.setState({search:value})
                                    }}
                                    onKeyDown={(event)=>{
                                        if (event.key === 'Enter') {
                                            let value = event.target.value
                                            value = cleanNonNumeric(value)
                                            this.setState({value}, () => {
                                                if(value!=''){
                                                    this.findInspection(value)
                                                    // onSearch(value)
                                                }
                                            })
                                        }
                                    }}
                                />
                            </Col>
                        </Row>
                        {serverMessage&&(
                            <Row>
                                <Col className="p-1 mb-2">
                                    <span className="text-danger font-italic">{serverMessage}</span>
                                </Col>
                            </Row>

                        )}
                        <Row>
                            <Col className="ps-2 pe-2 mb-1">
                                <Button
                                    block
                                    variant="primary"
                                    className="w-100"
                                    aria-label="Submit"
                                    onClick={(e)=>{
                                        e.preventDefault()
                                        this.findInspection(search)
                                        // this.props.onClose()
                                    }}>
                                    {label.Search}
                                </Button>
                            </Col>
                        </Row>
                        <Row>
                            <Col className="ps-2 pe-2 mb-1">
                                <Button
                                    block
                                    variant="outline-dark"
                                    className="w-100"
                                    aria-label="Close"
                                    onClick={()=>{
                                        this.props.onClose()
                                    }}>
                                    {label.Close}
                                </Button>
                            </Col>
                        </Row>
                    </Modal.Body>
                </Modal>
            </>
        );
    }

}
AssemblyFromFindInspectionModal.propTypes = {
    show:PropTypes.bool.isRequired,
    onClose:PropTypes.func.isRequired,
    onSearch:PropTypes.func,
    onSearchResult:PropTypes.func

}
